import { formatNumber } from '@forwardflow/helpers/utils/formatNumber'
import Icon from '@forwardflow/ui/Icons'
import { Avatar } from 'antd'

type prop = {
   direction?: 'row' | 'col'
   agentsWithMostContracts?: any
   count?: number
}

export const AgentsWithMostContracts: React.FC<prop> = ({
   direction = 'row',
   agentsWithMostContracts = [],
   count = 3,
}) => {
   return (
      <div className="bg-[#3B3C42] h-full rounded">
         <div className="px-8 py-5 border-b border-white/20 text-[14px] font-medium flex items-center justify-between">
            <span>Agents with most contracts</span>
            <div className="flex items-center cursor-pointer gap-x-2 hover:opacity-80">
               <span className="text-[#AB7AE0] items-center gap-x-2 hidden">
                  View all
               </span>
               <Icon
                  name="ArrowRightSmall"
                  className="stroke-[#AB7AE0] mt-1 hidden"
               />
            </div>
         </div>
         <div
            className={`py-4 px-7 overflow-y-auto max-h-[290px] ${
               direction === 'row'
                  ? 'grid grid-cols-3 gap-4'
                  : 'flex flex-col gap-2'
            }`}
         >
            {agentsWithMostContracts && agentsWithMostContracts.length > 0 ? (
               agentsWithMostContracts
                  ?.slice(0, count)
                  ?.map((agent: any, index: number) => {
                     return (
                        <div
                           key={index}
                           className="bg-[#2C2D32] rounded p-3 flex items-center gap-x-3"
                        >
                           <Avatar className="flex-shrink-0 w-10 h-10">
                              {agent?.user?.name?.charAt(0)}
                           </Avatar>
                           <div className="flex flex-col text-[14px] font-medium truncate">
                              <p className="truncate">{agent?.user?.name}</p>
                              <p>
                                 <span className="text-[20px]">
                                    {formatNumber(agent?.totals?.contracts)}
                                 </span>
                                 / {formatNumber(agent?.totals?.assigned)}
                              </p>
                           </div>
                        </div>
                     )
                  })
            ) : (
               <div className="flex items-center justify-center py-8 col-span-full">
                  <p className="text-white/70 text-[14px]">
                     No agents with contracts available
                  </p>
               </div>
            )}
         </div>
      </div>
   )
}
